import { registerPageInit } from '../barba/page-init-registry';
import {
  initDateRangePicker,
  populateDateRangeFromURL,
} from '../utils/date-range-picker';
import { updateRangeEmptySummary } from '../utils/date-range-summary';
import { initNewsFiltersAutoSubmit } from '../utils/news-filters';
import { initNewsFeedLoadMore } from '../utils/news-feed-load-more';
import { applyServerSearchResults, initSearchInput } from '../utils/search-input';
import '../../css/_root.scss';
import '../../css/pages/news/index.scss';

function getNewsFeedScope(root?: ParentNode): ParentNode {
  return (
    root?.querySelector<HTMLElement>('[data-barba-namespace="news-feed"]') ?? root ?? document
  );
}

class NewsFeed {
  public init(root?: ParentNode): void {
    const scope = getNewsFeedScope(root);
    initDateRangePicker(scope);
    populateDateRangeFromURL(scope);
    initSearchInput(scope, { mode: 'server', urlParam: 'q' });
    const ajaxConfig = {
      gridSelector: '[data-news-grid]',
      wrapSelector: '[data-news-load-more-wrap]',
      cardSelector: 'article.news-card',
      loadingSelector: '.news-content',
      skeletonVariant: 'news' as const,
      skeletonCount: 6,
      search: {
        inputId: 'news-search',
        highlight: {
          cardSelector: 'article.news-card',
          fields: [{ selector: '.news-card__title' }, { selector: '.news-card__excerpt' }],
        },
      },
    };

    initNewsFiltersAutoSubmit(scope, { ajax: ajaxConfig });
    initNewsFeedLoadMore(scope);
    updateRangeEmptySummary(scope, ajaxConfig);

    const urlQuery = new URLSearchParams(window.location.search).get('q');
    if (urlQuery) {
      applyServerSearchResults(scope, urlQuery, ajaxConfig.search);
    }
  }
}

registerPageInit('news-feed', (root) => {
  const page = new NewsFeed();
  page.init(root);
});
